{
  "navigation": {
    "search": "Søk",
    "aktorer": "AKTØRER",
    "skogeier": "Skogeier",
    "timberbuyer": "Tømmerkjøper",
    "contractor": "Entreprenør",
    "framework": "Framework",
    "shortcuts": "SNARVEIER",
    "skogmodul": "Skogmodul"
  },
  "assortment": "Sortiment",
  "bulkSms": "Masseutsendelse av SMS"
}
